/* global google */
/* global L */
import PropTypes from 'prop-types';

import React from 'react';
import MarkerClusterer from 'marker-clusterer-plus';

import {withMap} from './utils';

class Clusterer extends React.Component {
  static displayName = 'Clusterer';

  static propTypes = {
    children: PropTypes.node,
    map: PropTypes.object,
    maxZoom: PropTypes.number,
  };

  static childContextTypes = {
    clusterer: PropTypes.object,
  };

  state = {clusterer: null};

  getChildContext() {
    return {clusterer: this.state.clusterer};
  }

  componentDidUpdate() {
    // Redraw the clusterer when it re-renders since it doesn't do this
    // automatically when markers are added/removed/updated
    if (this.state.clusterer) this.state.clusterer.repaint();
  }

  _buildClusterer = (el) => {
    if (!el || this.state.clusterer) return;
    const clusterer = new MarkerClusterer(this.props.map, [], {
      maxZoom: this.props.maxZoom || 15,
      averageCenter: true,
      gridSize: 75,
    });
    this.setState({clusterer});
  };

  render() {
    return (
      <div className="Clusterer" ref={this._buildClusterer}>{this.props.children}</div>
    );
  }
}

export default withMap(Clusterer);



// WEBPACK FOOTER //
// ./src/common/components/BetterMap/Clusterer.js